import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import { BIND_TICKET_KEY, mpOauthCallback, useMAuth } from '../mApi';

// /m/callback：微信网页授权回调（code → 登录态 / bind ticket → 绑定流程）
const handledCodes = new Set<string>();

export default function MCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const setAuth = useMAuth((s) => s.setAuth);
  const [err, setErr] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get('code') || '';
    const state = params.get('state') || undefined;
    if (!code) {
      setErr('缺少 code 参数（请从 /m 重新发起登录）');
      return;
    }
    // StrictMode 双挂载 / 重复回跳时防抖：同一 code 只处理一次
    if (handledCodes.has(code)) return;
    handledCodes.add(code);
    mpOauthCallback(code, state)
      .then((r) => {
        if (r.bound && r.token && r.user) {
          setAuth(r.token, r.user);
          nav('/m', { replace: true });
        } else if (r.ticket) {
          sessionStorage.setItem(BIND_TICKET_KEY, r.ticket);
          nav('/m/login?bind=1', { replace: true });
        } else {
          setErr('授权失败：未取得登录态');
        }
      })
      .catch((e: Error) => setErr(e.message || '授权失败'));
  }, [params, nav, setAuth]);

  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      {err ? (
        <div style={{ maxWidth: 420, margin: '0 auto' }}>
          <Alert type="warning" showIcon message="微信授权失败" description={err} />
          <a href="/m/login" style={{ display: 'inline-block', marginTop: 16, color: '#4e9eff' }}>返回登录 →</a>
        </div>
      ) : (
        <>
          <Spin size="large" />
          <div style={{ color: '#8a8aa3', marginTop: 16 }}>微信授权中…</div>
        </>
      )}
    </div>
  );
}
